<template>
  <div class="home">
      <Vireed class="marginal" ></Vireed>
  </div>
</template>

<script>
import Vireed from '@/components/VireedProjectForm.vue';
export default {
  name: 'VireedNewProject',
  components: {
    Vireed
  }
}
</script>